import { shopSignup } from '../../../actions/shop/signup/shopSignup';
import { toastr } from 'react-redux-toastr';

async function submit(values, dispatch) {
    let addressError, phoneNumberError;

    values.address ? addressError = false : addressError = true;
    values.phoneNumber ? phoneNumberError = false : phoneNumberError = true;

    if (addressError) {
        return toastr.error('Error', 'Please provide address.')
    } else if (phoneNumberError) {
        return toastr.error('Error', 'Please provide phone number.')
    } else if (!values.isTermsCondtions) {
        return toastr.error('Error', 'Please agree to the terms and conditions of EazyEat platform to proceed further')
    } else {
        await dispatch(shopSignup(values));
    }

};

export default submit;
